// extracted by mini-css-extract-plugin
export default {"banner":"VpFYv","banner__content":"mgy2X","banner__footer":"EW931"};